type FormInstance = {
  isDirty: () => boolean;
};

let formInstance: FormInstance | null = null;

export const registerFormInstance = (instance: FormInstance) => {
  formInstance = instance;
};

export const unregisterFormInstance = () => {
  formInstance = null;
};

export const isFormDirty = (): boolean =>
  formInstance ? formInstance.isDirty() : false;
